import { Button, Input } from '@/components'
import { TInput } from '@/components/forms/form-elements/types'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import React, { useEffect, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import commonUtils from '@/utils/commonUtils'

interface DataRow {
  cmpnyCd: string
  codeType: string
  codeTypeNm: string
  mainTable: string
  mainColumn: string
  totalCount: number
  useCount: number
  regId: string
  regDate: string
  updId: string
  updDate: string
}

const ComCode: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState<DataRow[]>([])

  const [search, setSearch] = useState(location.state?.search || '')
  const [currentPage, setCurrentPage] = useState(location.state?.page || 1)
  const [perPage, setPerPage] = useState(location.state?.perPage || 10)

  const columns: TableColumn<DataRow>[] = [
    // {
    //     name: 'No.',
    //     selector: (row) => row.rnum,
    //     sortable: true,
    //     center: true,
    //     wrap: true,
    // },
    {
      name: '코드유형',
      selector: (row) => row.codeType,
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: '코드유형명',
      selector: (row) => row.codeTypeNm,
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: '메인테이블',
      selector: (row) => row.mainTable,
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '메인컬럼',
      selector: (row) => row.mainColumn,
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '총개수',
      selector: (row) => row.totalCount,
      sortable: true,
      wrap: true,
      width: '8%',
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>
          {row.totalCount}
        </div>
      ),
    },
    {
      name: '총사용수',
      selector: (row) => row.useCount,
      sortable: true,
      wrap: true,
      width: '8%',
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.useCount}</div>
      ),
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '수정일시',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate, false),
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: '',
      cell: (row) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleButtonUpdateClick(row.codeType)}
          >
            수정
          </Button>
        </>
      ),
      center: true,
      sortable: false,
    },
  ]
  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setSearch(value)
  }

  const handleButtonUpdateClick = (codeType: string) => {
    navigate(`/code/detail`, {
      state: {
        codeType: codeType,
        search: search,
        page: currentPage,
        perPage: perPage,
      },
    })
  }

  const getComCodeList = async () => {
    try {
      const response = await axios.get('/comCode/list', {
        params: { search: search },
      })

      const listData = response.data.data.list

      if (Array.isArray(listData)) {
        setData(listData)
      }
    } catch (error) {
      console.error('Error fetching term list:', error)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getComCodeList()
    }
  }

  useEffect(() => {
    getComCodeList()
  }, [])

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>공통코드관리</p>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Input
              placeholder="코드유형이나 코드유형명을 입력하세요"
              width="300px"
              id="srchStr"
              name="srchStr"
              value={search}
              onChange={handleSearch}
              onKeyDown={handleKeyDown}
            />
            <FlexWrapper gap="10px">
              <Button
                onClick={getComCodeList}
                color="neverbe"
                variant="outlined"
              >
                검색
              </Button>
              <Button
                onClick={() => {
                  navigate('/code/detail', {
                    state: {
                      search: search,
                      page: currentPage,
                      perPage: perPage,
                    },
                  })
                }}
                color="neverbe"
              >
                등록
              </Button>
            </FlexWrapper>
          </div>
        </div>
      </div>
      <DataTable
        // TODO 페이징처리는 서버 vs 클라이언트 (현행 클라이언트)
        columns={columns}
        data={data}
        // customStyles={tableStyles}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        pagination={true}
        paginationPerPage={perPage}
        onChangeRowsPerPage={(page) => setPerPage(page)}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
        noDataComponent={<>조회결과가 없습니다.</>}
      />
    </>
  )
}

export default ComCode
